<template>
  <router-view></router-view>
</template>

<script setup>
import { onMounted } from 'vue'
onMounted(async () => {
  if (window.location.search.includes('vconsole=yes_do_open')) {
    console.log('vConsole is showing')
    const vConsole = (await import('vconsole')).default
    // 初始化vConsole调试工具
    new vConsole()
  }
})
</script>
<style>
:root {
  --el-color-primary: #004422 !important;
}
</style>
